/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScorecardStatus = {
    Processing: 'Processing',
    Processed: 'Processed',
    Completed: 'Completed',
    Ready: 'Ready'
} as const;
export type ScorecardStatus = typeof ScorecardStatus[keyof typeof ScorecardStatus];


export function ScorecardStatusFromJSON(json: any): ScorecardStatus {
    return ScorecardStatusFromJSONTyped(json, false);
}

export function ScorecardStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardStatus {
    return json as ScorecardStatus;
}

export function ScorecardStatusToJSON(value?: ScorecardStatus | null): any {
    return value as any;
}

